export const ATTEMPTS_HUB_NAME = "attempts";
